<template>
  <v-container fluid class="pa-0">
    <v-sheet style="background-color: transparent">
      <v-slide-group v-model="model" show-arrows="desktop">
        <v-slide-item
          class="mb-2 mr-1"
          v-for="(item, index) in dataItems"
          :key="index"
          style="width: 160px"
        >
          <div class="ma-2">
            <v-card
              class="rounded-lg py-2 px-2 card-container"
              outlined
              elevation="1"
              style="border: none"
            >
              <v-img
                :cover="true"
                :aspect-ratio="1"
                height="120px"
                :src="
                  item.profile_path
                    ? item.profile_path
                    : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'
                "
              >
              </v-img>
              <div
                v-for="(data, j) in cardTitleFriend"
                :key="j"
                class="mb-0 text-detail"
              >
                <p
                  v-if="j == 0"
                  class="text-start mb-auto text-subtitle-2 black--text mb-0"
                >
                  {{ item.detail ? item.detail[data] : "-" }}
                </p>
                <p
                  v-else
                  style="font-size: 11px !important"
                  class="text-start mb-auto text-subtitle-2 black--text mb-0"
                >
                  {{ item.detail ? item.detail[data] : "-" }}
                </p>
              </div>
              <div>
                <v-btn
                  depressed
                  color="primary"
                  small
                  class="mt-4"
                  style="width: 100%; border-radius: 8px"
                  @click="addFriend(item)"
                >
                  {{ $t("addFriend") }}
                </v-btn>
              </div>
            </v-card>
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";

export default {
  name: "listFriendRecommend",
  props: ["dataItems", "cardTitleFriend", "site"],
  data() {
    return {
      model: 0,
      item: "",
      keyComponent: 0,
      dialogDetail: false,
    };
  },

  methods: {
    openDialog(item) {
      this.item = item;
      this.keyComponent++;
      this.dialogDetail = true;
    },
    getFriendRecommend() {
      Axios.get("friend/listFriendRecommend")
        .then(({ data }) => {
          this.dataItems = data.data.data;
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },

    addFriend(item) {
      this.$emit("addFriend", item);
    },
  },
  computed: {},
  filters: {},
};
</script>

<style scoped>
.card-container {
  position: relative;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
}
.container1 {
  position: relative;
}
.btn-close {
  position: absolute;
  z-index: 888;
}
.text-over-image {
  background-color: blue;
  color: white;
  font-weight: bold;
  margin-right: 0;
  float: right;
}
.close-button {
  background-color: rgba(0, 0, 0, 0.25);
}
.text-detail {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
}
</style>
